import { debounce } from 'lodash';

const ohsDebounce = (func: any) => {
  return debounce(func, 300);
};

export default ohsDebounce;
